import "./AppFooter.css";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { classNamesFunction } from "@fluentui/react/lib/Utilities";
import {
  getCurrentTheme,
  setIsBotError,
  setIsLoader,
  settitleLoaderName,
} from "../../../core/store";
import { getStyles } from "./AppFooter.styles";
import { FooterProps } from "./AppFooter.types";
import { ServiceContext } from "@msx/platform-services";
import { ChatBot, ExtendedChatBotProps } from "./ChatBot";
import { IRISBotSettings, getIrisSelfHelp } from "./IrisSelfHelpContext";
import { checkIrisUtterance, checkTileParameterScenario, finalIrisUtterance, finalSearchTerm, finalTileName, isIrisMenuINDOM} from "./getFunctionsForFooter";


const getClassNames = classNamesFunction<any, any>();
let classes: any;

const AppFooterComponent: React.FC<FooterProps> = (props) => {

  let irisBot=false
  const reduxDispatch = useDispatch();

  const [irisContext, setIrisContext] = useState("");
  const [tileName, setTileName] = useState("");
  const [iriscontext, setcontext] = useState("");

  const [searchTerm, setSearchTerm] = useState(null);
  const [irisTokenCreated, setIrisTokenCreated] = useState(null);
  // Tracks whether the user explicitly opened Iris via the header icon.
  // Once true, the tile-context readiness gate is bypassed so general
  // (non-tile) chat launches are never blocked on a parameterized URL page.
  const [hasManuallyOpened, setHasManuallyOpened] = useState(false);
  const context = React.useContext(ServiceContext);
  const currentUserData = props.currentUserData;
  
  useEffect(() => {
  checkIrisUtterance(
    props.irisUtterance,
    props.setShowBot,
    setcontext,
    setTileName,
    props.tileName,
    props.setChatBotClicked,
    setIrisContext
  );
  }, [props.irisUtterance, props.setIrisAppName,props.formDataToIris, props.tileName,props.chatBotClicked]);




  // Extract tile identity fields so the dependency array uses simple values
  // (avoids the react-hooks "complex expression in dependency array" warning).
  const finalTileIsIncidentTile = props.finalTileObject["isIncidentTile"];
  const finalTileNameValue = props.finalTileObject["TileName"];
  useEffect(() => {
    checkTileParameterScenario(props.finalTileObject,setIrisContext,setSearchTerm,setTileName);
    // Depend on the tile object's identity (isIncidentTile + TileName) so this
    // re-runs when the tile configuration finishes loading asynchronously.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalTileIsIncidentTile, finalTileNameValue, props.tileName]);

 

  useEffect(() => {
    isIrisBotClicked();
  }, [props.irisBotIconClicked]);

  const isIrisBotClicked = ()=>{
    if (props.irisBotIconClicked === true) handleChatBotIconClick();
  }

  const theme = useSelector(getCurrentTheme);
  classes = getClassNames(getStyles, theme);



  const chatBotProps: ExtendedChatBotProps = {
    irisSelfHelp: iriscontext
      ? getIrisSelfHelp(
        finalIrisUtterance(irisContext,props.irisUtterance),
          currentUserData,
          IRISBotSettings.WORKSTREAM,
          finalSearchTerm(searchTerm,props.SearchTerm),
          props.formDataToIris,
          finalTileName(tileName,props.tileName),
          props.finalTileObject,
          props?.Segment,
          props?.SubSegment
        )
      : null,
    appName: props.setIrisAppName
      ? props.setIrisAppName
      : IRISBotSettings.APP_NAME,
    platform: IRISBotSettings.PLATFORM_NAME,
  };


 const checkIrisMenu = () => {
    if(!irisBot){
    const irisMenu = document.querySelector(".ms-layer");
    isIrisMenuINDOM(irisMenu,reduxDispatch,setIsLoader,irisBot,checkIrisMenu);
  }
  };  

 
  const handleChatBotIconClick = async () => {
    reduxDispatch(setIsLoader(true));
    reduxDispatch(setIsBotError(false));
    reduxDispatch(settitleLoaderName(""));

    try {
      irisBot=false;
      checkIrisMenu();
      if ( context?.telemetryClient) {
        props.setShowBot(true);
        setHasManuallyOpened(true);
        setcontext("set context");
        setIrisContext("");
        setTileName("");
        setIrisTokenCreated(null);
        props.setIrisBotIconClicked(false);
      }
    } catch (error) {
      reduxDispatch(setIsBotError(true));
      console.error("API Error:", error);
    }
  };

  const closeBot = () => {
    props.setShowBot(false);
    setIrisContext(null);
    setTileName(null);
    if (props.resetShellIrisContext) {
      props.resetShellIrisContext();
    }
    props.setIrisBotIconClicked(false);
  };

    const renderBot = () =>
  {
    // Iris greeting race fix: on a parameterized tile URL (?TileName=...&Mode=incident)
    // the proactive Copilot greeting is a one-shot event, so defer the mount until
    // the tile context is ready or the greeting comes back generic. The gate does
    // not apply to non-PURL pages or after a manual open, so general chat launches
    // are never blocked.
    const urlParams = new URLSearchParams(window.location.search);
    const isParameterizedTileUrl = Array.from(urlParams.keys()).some(
      (key) => key.toLowerCase() === "tilename"
    );
    // Gate on the effective tileName that actually feeds the greeting (not just the
    // tile config prop): the payload tileName is set by a post-render effect one
    // render later, so on cached-token rapid refresh the one-shot event could
    // otherwise fire with an empty tile. Scoped to incident tiles so others are
    // never blocked.
    const effectiveTileName = finalTileName(tileName, props.tileName);
    const tileConfigLoaded =
      Boolean(props.finalTileObject?.["TileName"]) ||
      Boolean(props.finalTileObject?.["Error"]);
    const isIncidentTile = Boolean(props.finalTileObject?.["isIncidentTile"]);
    const tileNamePayloadReady =
      !isIncidentTile ||
      Boolean(effectiveTileName) ||
      Boolean(props.finalTileObject?.["Error"]);
    const isTileContextResolved = tileConfigLoaded && tileNamePayloadReady;
    const awaitingTileContext =
      isParameterizedTileUrl && !hasManuallyOpened && !isTileContextResolved;

    const isRendered = props.ShowBot &&
    props.IsUserAuthorized && 
    chatBotProps.irisSelfHelp !== null &&
    !awaitingTileContext;

     return <div>
     {isRendered &&(
         <ChatBot
           {...chatBotProps}
           closeBotHandler={closeBot}
           showBot={props.ShowBot}
           irisApiBaseUrl={process.env.REACT_APP_CHATBOT_BASE_URL}
           irisToken={props.irisToken}
           irisTokenCreated={irisTokenCreated}
           setIrisTokenCreated={setIrisTokenCreated}
         />
       ) }
   </div>

  }

  const renderMain = (): JSX.Element => {
    return (
      <>
      <footer
        className={classes.container}
        style={{ backgroundColor: "#f5f5f5" }}
      >
       { renderBot()}
      </footer>
      </>
    );
  };
  return renderMain();



};

export const AppFooter = injectIntl(AppFooterComponent);

// Generated by Copilot
// updated on: 2026-07-01 | ~30 lines added | [Auto Generated] | Fix Iris Copilot greeting race: defer proactive mount on parameterized tile URLs until tile config loads; fix stale useEffect dependency | Time Taken 20 min
// updated on: 2026-07-03 | ~20 lines added | [Auto Generated] | Harden greeting race fix: gate mount on the effective payload tileName (not just tile config prop) so cached-token rapid refresh cannot fire the one-shot proactive event with an empty tile | Time Taken 15 min
